module.exports = __webpack_public_path__ + "img/sms.fd5deca3.svg";